import { Injectable, InjectionToken } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from "@angular/common/http";
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ModuleConfig } from '../models/module-config.interface';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class FarmnetModuleService {
    readonly NGX_TYPE_PREFIX = 'ngx';
    private modules: ModuleConfig[] = window.app.modules;
    private ngxSubject = new Subject<ModuleConfig[]>();
    private ngSubject = new Subject<ModuleConfig[]>();

    constructor(private httpClient: HttpClient) {
        setInterval(()=> {
            this.loadAndStoreModuleInfo()
                .subscribe(() => {
                    this.ngxSubject.next(this.getNgxModules());
                    this.ngSubject.next(this.getNgModules());
                });
        }, 5 * 60 * 1000);
    }

    getNgxModules(): ModuleConfig[] {
        return this.modules
            .map(m=> m.name == 'coredata-service' ? {
                ...m,
                library: 'CoredataServiceModule',
                type: this.NGX_TYPE_PREFIX
            }:m)
            .filter(m => m.type && m.type.startsWith(this.NGX_TYPE_PREFIX));
    }

    getNgModules(): ModuleConfig[] {
        return this.modules
            .map(module => {
                return {
                    ...module,
                    serie: true,
                    loadlazily: true
                }
            })
            .filter(m => !m.type || (m.type && m.type === 'ng'));
    }

    findNgxModule(moduleName: string): ModuleConfig | undefined {
        return this.getNgxModules()
            .find((module) => module.name === moduleName);
    }

    hasNgxModule(moduleName: string): boolean {
        return !!this.findNgxModule(moduleName);
    }

    ngxModulesUpdate(): Observable<ModuleConfig[]> {
        return this.ngxSubject;
    }

    ngModulesUpdate(): Observable<ModuleConfig[]> {
        return this.ngSubject;
    }

    getModules(): ModuleConfig[] {
        return this.modules;
    }


    findModule(moduleName: string): ModuleConfig | undefined {
        return this.getModules()
            .find((module) => module.name === moduleName);
    }

    hasModule(moduleName: string): boolean {
        return !!this.findModule(moduleName);
    }

    loadAndStoreModuleInfo() {
        console.log('updating farmnet modules');
        return this.httpClient.get<ModuleConfig[]>('/365FarmNet/mod/mms/moduleinfo')
            .pipe(
                map(moduleInfos => {
                    const mappedModuleInfos = moduleInfos.map((module : any) => {
                        module.files = module.files.map((filename : string) => {
                            return `../mod/${module.name}/${filename}`;
                        });

                        return module;
                    });
                    return mappedModuleInfos;
                })
            )
            .pipe(
                tap(moduleInfos => {
                    this.modules = moduleInfos;
                    window.app.modules = moduleInfos;
                })
            )
    }
}
